
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11409",
                "data-name": "矩形 11409",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.5 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_347",
        "data-name": "蒙版组 347",
        "class": "cls-2",
        "transform": "translate(0.5 0)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "bingxiang",
            "class": "cls-3",
            "d": "M92.612,0A.974.974,0,0,1,93.6.96V17.28a.974.974,0,0,1-.988.96H90.635v.24a.741.741,0,0,1-1.482,0v-.24H81.247v.24a.741.741,0,0,1-1.482,0v-.24H77.788a.974.974,0,0,1-.988-.96V.96A.974.974,0,0,1,77.788,0Zm0,9.6H77.788v7.2a.487.487,0,0,0,.494.48H92.118a.487.487,0,0,0,.494-.48ZM80.259,11.04a.487.487,0,0,1,.494.48v1.92a.494.494,0,0,1-.988,0V11.52A.487.487,0,0,1,80.259,11.04ZM92.118.96H78.282a.487.487,0,0,0-.494.48v7.2H92.612V1.44a.487.487,0,0,0-.494-.48ZM80.259,4.32a.487.487,0,0,1,.494.48V6.72a.494.494,0,0,1-.988,0V4.8A.487.487,0,0,1,80.259,4.32Z",
            "transform": "translate(-72.6 3)"
          }
        }
      ]
    }
  ]
})
    }
  